// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card__2DtCw","card__img":"index_card__img__16zJ8","card__title":"index_card__title__2otXo","card__time":"index_card__time__accJ0"};